
export default function NotificationsPage() {
  return (
    <div>
      <h1>Notifications</h1>
      <p>Manage notifications here.</p>
    </div>
  );
}
